const countries = [
    { name: 'United States', code: 'US', flag: '🇺🇸', dialCode: '+1' },
    { name: 'Afghanistan', code: 'AF', flag: '🇦🇫', dialCode: '+93' },
    { name: 'Albania', code: 'AL', flag: '🇦🇱', dialCode: '+355' },
    { name: 'Algeria', code: 'DZ', flag: '🇩🇿', dialCode: '+213' },
    { name: 'Andorra', code: 'AD', flag: '🇦🇩', dialCode: '+376' },
    { name: 'Angola', code: 'AO', flag: '🇦🇴', dialCode: '+244' },
    { name: 'Argentina', code: 'AR', flag: '🇦🇷', dialCode: '+54' },
    { name: 'Armenia', code: 'AM', flag: '🇦🇲', dialCode: '+374' },
    { name: 'Australia', code: 'AU', flag: '🇦🇺', dialCode: '+61' },
    { name: 'Austria', code: 'AT', flag: '🇦🇹', dialCode: '+43' },
    { name: 'Azerbaijan', code: 'AZ', flag: '🇦🇿', dialCode: '+994' },
    { name: 'Bahamas', code: 'BS', flag: '🇧🇸', dialCode: '+1242' },
    { name: 'Bahrain', code: 'BH', flag: '🇧🇭', dialCode: '+973' },
    { name: 'Bangladesh', code: 'BD', flag: '🇧🇩', dialCode: '+880' },
    { name: 'Barbados', code: 'BB', flag: '🇧🇧', dialCode: '+1246' },
    { name: 'Belarus', code: 'BY', flag: '🇧🇾', dialCode: '+375' },
    { name: 'Belgium', code: 'BE', flag: '🇧🇪', dialCode: '+32' },
    { name: 'Belize', code: 'BZ', flag: '🇧🇿', dialCode: '+501' },
    { name: 'Benin', code: 'BJ', flag: '🇧🇯', dialCode: '+229' },
    { name: 'Bhutan', code: 'BT', flag: '🇧🇹', dialCode: '+975' },
    { name: 'Bolivia', code: 'BO', flag: '🇧🇴', dialCode: '+591' },
    { name: 'Bosnia and Herzegovina', code: 'BA', flag: '🇧🇦', dialCode: '+387' },
    { name: 'Botswana', code: 'BW', flag: '🇧🇼', dialCode: '+267' },
    { name: 'Brazil', code: 'BR', flag: '🇧🇷', dialCode: '+55' },
    { name: 'Brunei', code: 'BN', flag: '🇧🇳', dialCode: '+673' },
    { name: 'Bulgaria', code: 'BG', flag: '🇧🇬', dialCode: '+359' },
    { name: 'Burkina Faso', code: 'BF', flag: '🇧🇫', dialCode: '+226' },
    { name: 'Burundi', code: 'BI', flag: '🇧🇮', dialCode: '+257' },
    { name: 'Cambodia', code: 'KH', flag: '🇰🇭', dialCode: '+855' },
    { name: 'Cameroon', code: 'CM', flag: '🇨🇲', dialCode: '+237' },
    { name: 'Canada', code: 'CA', flag: '🇨🇦', dialCode: '+1' },
    { name: 'Cape Verde', code: 'CV', flag: '🇨🇻', dialCode: '+238' },
    { name: 'Central African Republic', code: 'CF', flag: '🇨🇫', dialCode: '+236' },
    { name: 'Chad', code: 'TD', flag: '🇹🇩', dialCode: '+235' },
    { name: 'Chile', code: 'CL', flag: '🇨🇱', dialCode: '+56' },
    { name: 'China', code: 'CN', flag: '🇨🇳', dialCode: '+86' },
    { name: 'Colombia', code: 'CO', flag: '🇨🇴', dialCode: '+57' },
    { name: 'Comoros', code: 'KM', flag: '🇰🇲', dialCode: '+269' },
    { name: 'Congo, Democratic Republic of the', code: 'CD', flag: '🇨🇩', dialCode: '+243' },
    { name: 'Congo, Republic of the', code: 'CG', flag: '🇨🇬', dialCode: '+242' },
    { name: 'Costa Rica', code: 'CR', flag: '🇨🇷', dialCode: '+506' },
    { name: 'Croatia', code: 'HR', flag: '🇭🇷', dialCode: '+385' },
    { name: 'Cuba', code: 'CU', flag: '🇨🇺', dialCode: '+53' },
    { name: 'Cyprus', code: 'CY', flag: '🇨🇾', dialCode: '+357' },
    { name: 'Czech Republic', code: 'CZ', flag: '🇨🇿', dialCode: '+420' },
    { name: 'Denmark', code: 'DK', flag: '🇩🇰', dialCode: '+45' },
    { name: 'Djibouti', code: 'DJ', flag: '🇩🇯', dialCode: '+253' },
    { name: 'Dominica', code: 'DM', flag: '🇩🇲', dialCode: '+1767' },
    { name: 'Dominican Republic', code: 'DO', flag: '🇩🇴', dialCode: '+1809' },
    { name: 'Ecuador', code: 'EC', flag: '🇪🇨', dialCode: '+593' },
    { name: 'Egypt', code: 'EG', flag: '🇪🇬', dialCode: '+20' },
    { name: 'El Salvador', code: 'SV', flag: '🇸🇻', dialCode: '+503' },
    { name: 'Equatorial Guinea', code: 'GQ', flag: '🇬🇶', dialCode: '+240' },
    { name: 'Estonia', code: 'EE', flag: '🇪🇪', dialCode: '+372' },
    { name: 'Ethiopia', code: 'ET', flag: '🇪🇹', dialCode: '+251' },
    { name: 'Fiji', code: 'FJ', flag: '🇫🇯', dialCode: '+679' },
    { name: 'Finland', code: 'FI', flag: '🇫🇮', dialCode: '+358' },
    { name: 'France', code: 'FR', flag: '🇫🇷', dialCode: '+33' },
    { name: 'Gabon', code: 'GA', flag: '🇬🇦', dialCode: '+241' },
    { name: 'Gambia', code: 'GM', flag: '🇬🇲', dialCode: '+220' },
    { name: 'Georgia', code: 'GE', flag: '🇬🇪', dialCode: '+995' },
    { name: 'Germany', code: 'DE', flag: '🇩🇪', dialCode: '+49' },
    { name: 'Ghana', code: 'GH', flag: '🇬🇭', dialCode: '+233' },
    { name: 'Greece', code: 'GR', flag: '🇬🇷', dialCode: '+30' },
    { name: 'Guatemala', code: 'GT', flag: '🇬🇹', dialCode: '+502' },
    { name: 'Guinea', code: 'GN', flag: '🇬🇳', dialCode: '+224' },
    { name: 'Guyana', code: 'GY', flag: '🇬🇾', dialCode: '+592' },
    { name: 'Haiti', code: 'HT', flag: '🇭🇹', dialCode: '+509' },
    { name: 'Honduras', code: 'HN', flag: '🇭🇳', dialCode: '+504' },
    { name: 'Hungary', code: 'HU', flag: '🇭🇺', dialCode: '+36' },
    { name: 'Iceland', code: 'IS', flag: '🇮🇸', dialCode: '+354' },
    { name: 'India', code: 'IN', flag: '🇮🇳', dialCode: '+91' },
    { name: 'Indonesia', code: 'ID', flag: '🇮🇩', dialCode: '+62' },
    { name: 'Iran', code: 'IR', flag: '🇮🇷', dialCode: '+98' },
    { name: 'Iraq', code: 'IQ', flag: '🇮🇶', dialCode: '+964' },
    { name: 'Ireland', code: 'IE', flag: '🇮🇪', dialCode: '+353' },
    { name: 'Israel', code: 'IL', flag: '🇮🇱', dialCode: '+972' },
    { name: 'Italy', code: 'IT', flag: '🇮🇹', dialCode: '+39' },
    { name: 'Jamaica', code: 'JM', flag: '🇯🇲', dialCode: '+1876' },
    { name: 'Japan', code: 'JP', flag: '🇯🇵', dialCode: '+81' },
    { name: 'Jordan', code: 'JO', flag: '🇯🇴', dialCode: '+962' },
    { name: 'Kazakhstan', code: 'KZ', flag: '🇰🇿', dialCode: '+7' },
    { name: 'Kenya', code: 'KE', flag: '🇰🇪', dialCode: '+254' },
    { name: 'Kuwait', code: 'KW', flag: '🇰🇼', dialCode: '+965' },
    { name: 'Kyrgyzstan', code: 'KG', flag: '🇰🇬', dialCode: '+996' },
    { name: 'Latvia', code: 'LV', flag: '🇱🇻', dialCode: '+371' },
    { name: 'Lebanon', code: 'LB', flag: '🇱🇧', dialCode: '+961' },
    { name: 'Liberia', code: 'LR', flag: '🇱🇷', dialCode: '+231' },
    { name: 'Libya', code: 'LY', flag: '🇱🇾', dialCode: '+218' },
    { name: 'Lithuania', code: 'LT', flag: '🇱🇹', dialCode: '+370' },
    { name: 'Luxembourg', code: 'LU', flag: '🇱🇺', dialCode: '+352' },
    { name: 'Madagascar', code: 'MG', flag: '🇲🇬', dialCode: '+261' },
    { name: 'Malaysia', code: 'MY', flag: '🇲🇾', dialCode: '+60' },
    { name: 'Maldives', code: 'MV', flag: '🇲🇻', dialCode: '+960' },
    { name: 'Mali', code: 'ML', flag: '🇲🇱', dialCode: '+223' },
    { name: 'Malta', code: 'MT', flag: '🇲🇹', dialCode: '+356' },
    { name: 'Mauritania', code: 'MR', flag: '🇲🇷', dialCode: '+222' },
    { name: 'Mexico', code: 'MX', flag: '🇲🇽', dialCode: '+52' },
    { name: 'Moldova', code: 'MD', flag: '🇲🇩', dialCode: '+373' },
    { name: 'Monaco', code: 'MC', flag: '🇲🇨', dialCode: '+377' },
    { name: 'Mongolia', code: 'MN', flag: '🇲🇳', dialCode: '+976' },
    { name: 'Montenegro', code: 'ME', flag: '🇲🇪', dialCode: '+382' },
    { name: 'Morocco', code: 'MA', flag: '🇲🇦', dialCode: '+212' },
    { name: 'Mozambique', code: 'MZ', flag: '🇲🇿', dialCode: '+258' },
    { name: 'Myanmar', code: 'MM', flag: '🇲🇲', dialCode: '+95' },
    { name: 'Namibia', code: 'NA', flag: '🇳🇦', dialCode: '+264' },
    { name: 'Nepal', code: 'NP', flag: '🇳🇵', dialCode: '+977' },
    { name: 'Netherlands', code: 'NL', flag: '🇳🇱', dialCode: '+31' },
    { name: 'New Zealand', code: 'NZ', flag: '🇳🇿', dialCode: '+64' },
    { name: 'Nicaragua', code: 'NI', flag: '🇳🇮', dialCode: '+505' },
    { name: 'Niger', code: 'NE', flag: '🇳🇪', dialCode: '+227' },
    { name: 'Nigeria', code: 'NG', flag: '🇳🇬', dialCode: '+234' },
    { name: 'North Korea', code: 'KP', flag: '🇰🇵', dialCode: '+850' },
    { name: 'North Macedonia', code: 'MK', flag: '🇲🇰', dialCode: '+389' },
    { name: 'Norway', code: 'NO', flag: '🇳🇴', dialCode: '+47' },
    { name: 'Oman', code: 'OM', flag: '🇴🇲', dialCode: '+968' },
    { name: 'Pakistan', code: 'PK', flag: '🇵🇰', dialCode: '+92' },
    { name: 'Panama', code: 'PA', flag: '🇵🇦', dialCode: '+507' },
    { name: 'Paraguay', code: 'PY', flag: '🇵🇾', dialCode: '+595' },
    { name: 'Peru', code: 'PE', flag: '🇵🇪', dialCode: '+51' },
    { name: 'Philippines', code: 'PH', flag: '🇵🇭', dialCode: '+63' },
    { name: 'Poland', code: 'PL', flag: '🇵🇱', dialCode: '+48' },
    { name: 'Portugal', code: 'PT', flag: '🇵🇹', dialCode: '+351' },
    { name: 'Qatar', code: 'QA', flag: '🇶🇦', dialCode: '+974' },
    { name: 'Romania', code: 'RO', flag: '🇷🇴', dialCode: '+40' },
    { name: 'Russia', code: 'RU', flag: '🇷🇺', dialCode: '+7' },
    { name: 'Rwanda', code: 'RW', flag: '🇷🇼', dialCode: '+250' },
    { name: 'Saudi Arabia', code: 'SA', flag: '🇸🇦', dialCode: '+966' },
    { name: 'Senegal', code: 'SN', flag: '🇸🇳', dialCode: '+221' },
    { name: 'Serbia', code: 'RS', flag: '🇷🇸', dialCode: '+381' },
    { name: 'Sierra Leone', code: 'SL', flag: '🇸🇱', dialCode: '+232' },
    { name: 'Singapore', code: 'SG', flag: '🇸🇬', dialCode: '+65' },
    { name: 'Slovakia', code: 'SK', flag: '🇸🇰', dialCode: '+421' },
    { name: 'Slovenia', code: 'SI', flag: '🇸🇮', dialCode: '+386' },
    { name: 'Somalia', code: 'SO', flag: '🇸🇴', dialCode: '+252' },
    { name: 'South Africa', code: 'ZA', flag: '🇿🇦', dialCode: '+27' },
    { name: 'South Korea', code: 'KR', flag: '🇰🇷', dialCode: '+82' },
    { name: 'Spain', code: 'ES', flag: '🇪🇸', dialCode: '+34' },
    { name: 'Sri Lanka', code: 'LK', flag: '🇱🇰', dialCode: '+94' },
    { name: 'Sudan', code: 'SD', flag: '🇸🇩', dialCode: '+249' },
    { name: 'Sweden', code: 'SE', flag: '🇸🇪', dialCode: '+46' },
    { name: 'Switzerland', code: 'CH', flag: '🇨🇭', dialCode: '+41' },
    { name: 'Syria', code: 'SY', flag: '🇸🇾', dialCode: '+963' },
    { name: 'Taiwan', code: 'TW', flag: '🇹🇼', dialCode: '+886' },
    { name: 'Tanzania', code: 'TZ', flag: '🇹🇿', dialCode: '+255' },
    { name: 'Thailand', code: 'TH', flag: '🇹🇭', dialCode: '+66' },
    { name: 'Togo', code: 'TG', flag: '🇹🇬', dialCode: '+228' },
    { name: 'Trinidad and Tobago', code: 'TT', flag: '🇹🇹', dialCode: '+1868' },
    { name: 'Tunisia', code: 'TN', flag: '🇹🇳', dialCode: '+216' },
    { name: 'Turkey', code: 'TR', flag: '🇹🇷', dialCode: '+90' },
    { name: 'Uganda', code: 'UG', flag: '🇺🇬', dialCode: '+256' },
    { name: 'Ukraine', code: 'UA', flag: '🇺🇦', dialCode: '+380' },
    { name: 'United Arab Emirates', code: 'AE', flag: '🇦🇪', dialCode: '+971' },
    { name: 'United Kingdom', code: 'GB', flag: '🇬🇧', dialCode: '+44' },
    { name: 'Uruguay', code: 'UY', flag: '🇺🇾', dialCode: '+598' },
    { name: 'Uzbekistan', code: 'UZ', flag: '🇺🇿', dialCode: '+998' },
    { name: 'Venezuela', code: 'VE', flag: '🇻🇪', dialCode: '+58' },
    { name: 'Vietnam', code: 'VN', flag: '🇻🇳', dialCode: '+84' },
    { name: 'Yemen', code: 'YE', flag: '🇾🇪', dialCode: '+967' },
    { name: 'Zambia', code: 'ZM', flag: '🇿🇲', dialCode: '+260' },
    { name: 'Zimbabwe', code: 'ZW', flag: '🇿🇼', dialCode: '+263' },
];

export default countries;
